import { makeStyles, tokens } from '@fluentui/react-components';

export const useLiveAgentStyles = makeStyles({
  comment: {
    fontSize: tokens.fontSizeBase100,
    color: tokens.colorNeutralForeground4,
    lineHeight: tokens.fontSizeBase600,
    marginTop: tokens.spacingVerticalSNudge,
  },
  singleButton: {
    marginTop: tokens.spacingVerticalS,
    marginRight: tokens.spacingHorizontalXS,
    textAlign: 'left',
    textOverflow: 'ellipsis',
  },
  liveAgentCard: {
    clear: 'both',
    float: 'left',
    boxShadow: tokens.shadow2,
  },
  liveAgentSurveyCard: {
    clear: 'both',
    float: 'left',
    boxShadow: tokens.shadow2,
    width: '100%',
  },
  liveAgentCardContent: {
    whiteSpace: 'pre-line',
    color: tokens.colorNeutralForeground1,
  },
  liveAgentCardNote: {
    boxShadow: 'initial',
    clear: 'both',
    float: 'left',
    backgroundColor: tokens.colorNeutralBackground2,
  },
  liveAgentCardNoteContent: {
    fontSize: tokens.fontSizeBase200,
    lineHeight: tokens.fontSizeBase400,
    color: tokens.colorNeutralForeground2,
    marginTop: '-8px',
    textAlign: 'center',
  },
  liveAgentCardRadio: {
    fontWeight: tokens.fontWeightRegular,
    '& .fui-Radio__label': {
      fontWeight: '100 !important',
    },
  },
  liveAgentCenterContent: {
    fontSize: tokens.fontSizeBase200,
    textAlign: 'center',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    paddingTop: tokens.spacingVerticalS,
  },
});
